import loadable from '@loadable/component';

import { useFlag } from '@simplywallst/unleash';

const BetaTransactions = loadable(() => import('./BetaTransactions'), {
  resolveComponent: (c) => c.BetaTransactions,
});

const DeprecatedNewPortfolio = loadable(
  () => import('./DeprecatedNewPortfolio'),
  {
    resolveComponent: (c) => c.DeprecatedNewPortfolio,
  }
);

export const NewPortfolio = () => {
  const transactionsEntryPointFlag = useFlag(
    'mono-portfolio-transactions-entry-point'
  );

  const canAccessBetaTransactionsEntryPoint =
    transactionsEntryPointFlag.ready && transactionsEntryPointFlag.enabled;

  if (canAccessBetaTransactionsEntryPoint) {
    return <BetaTransactions />;
  }

  return <DeprecatedNewPortfolio />;
};
